module.exports = [
  {
    size: 12,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: false,
    cityview: false,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 0,
    single_beds: 0,
    terrace: false,
    balcony: false,
    id: 1,
    name: 'Apollonas',
    longName: 'Deluxe Suite Apollonas',
    desc: {
      en: 'Description in English',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/1/Apollonas_01.jpg',
      '/images/1/Apollonas_02.jpg',
      '/images/1/Apollonas_03.jpg',
      '/images/1/Apollonas_04.jpg',
      '/images/1/Apollonas_05.jpg',
      '/images/1/Apollonas_06.jpg',
      '/images/1/Apollonas_07.jpg',
      '/images/1/Apollonas_08.jpg',
      '/images/1/Apollonas_09.jpg',
      '/images/1/Apollonas_10.jpg',
      '/images/1/Apollonas_11.jpg',
    ],

    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 77 },
      { dates: '01/06-30/06', minStay: 3, rate: 107 },
      { dates: '01/07-31/07', minStay: 2, rate: 107 },
      { dates: '01/08-31/08', minStay: 3, rate: 132 },
      { dates: '01/09-30/09', minStay: 4, rate: 132 },
    ],
  },
  {
    size: 35,
    capacity: 4,
    kitchen: true,
    private_bathroom: true,
    seaview: true,
    cityview: true,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 1,
    single_beds: 0,
    terrace: true,
    balcony: true,
    id: 2,
    name: 'Salomi',
    longName: 'Deluxe Suite with Sea View Salomi',
    desc: {
      en: 'Boasting a private entrance, this air-conditioned suite comes with a kitchen, 1 bedroom and 1 bathroom with a walk-in shower and a hairdryer. Guests can make meals in the kitchen that features a stovetop, a refrigerator, kitchenware and a microwave. Featuring a terrace with sea views, this suite also features soundproof walls and a flat-screen TV with satellite channels. The unit has 2 beds.',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/2/Salome_01.jpg',
      '/images/2/Salome_02.jpg',
      '/images/2/Salome_03.jpg',
      '/images/2/Salome_04.jpg',
      '/images/2/Salome_05.jpg',
      '/images/2/Salome_06.jpg',
      '/images/2/Salome_07.jpg',
      '/images/2/Salome_08.jpg',
      '/images/2/Salome_09.jpg',
      '/images/2/Salome_10.jpg',
      '/images/2/Salome_11.jpg',
      '/images/2/Salome_12.jpg',
      '/images/2/Salome_13.jpg',
      '/images/2/Salome_14.jpg',
      '/images/2/Salome_15.jpg',
      '/images/2/Salome_16.jpg',
      '/images/2/Salome_17.jpg',
      '/images/2/Salome_18.jpg',
      '/images/2/Salome_19.jpg',
      '/images/2/Salome_20.jpg',
      '/images/2/Salome_21.jpg',
      '/images/2/Salome_22.jpg',
      '/images/2/Salome_23.jpg',
      '/images/2/Salome_24.jpg',
      '/images/2/Salome_25.jpg',
      '/images/2/Salome_26.jpg',
      '/images/2/Salome_27.jpg',
      '/images/2/Salome_28.jpg',
    ],
    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 88 },
      { dates: '01/06-30/06', minStay: 3, rate: 94 },
      { dates: '01/07-31/07', minStay: 2, rate: 133 },
      { dates: '01/08-31/08', minStay: 3, rate: 149 },
      { dates: '01/09-30/09', minStay: 4, rate: 149 },
    ],
  },
  {
    size: 28,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: false,
    cityview: true,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 0,
    single_beds: 0,
    terrace: false,
    balcony: true,
    id: 3,
    name: 'Victoria',
    longName: 'Deluxe Queen Suite Victoria',
    desc: {
      en: 'This suite includes a private balcony for this room only, furnished with a table and chairs. Access to the private balcony is through a separate shared balcony.',
      el: 'Αυτή η σουίτα διαθέτει ιδιωτικό μπαλκόνι αποκλειστικά για αυτό το δωμάτιο, με τραπέζι και καρέκλες. Η πρόσβαση στο ιδιωτικό μπαλκόνι γίνεται μέσω ξεχωριστού κοινόχρηστου μπαλκονιού.',
      de: 'Diese Suite verfügt über einen privaten Balkon ausschließlich für dieses Zimmer, mit Tisch und Stühlen. Der Zugang zum privaten Balkon erfolgt über einen separaten Gemeinschaftsbalkon.',
      sr: 'Овај апартман има приватан балкон намењен само овој соби, са столом и столицама. Приступ приватном балкону је преко одвојеног заједничког балкона.',
      ro: 'Această suită are un balcon privat destinat exclusiv acestei camere, mobilat cu masă și scaune. Accesul la balconul privat se face printr-un balcon comun separat.',
      fr: "Cette suite dispose d'un balcon privé réservé à cette chambre, avec une table et des chaises. L'accès au balcon privé se fait par un balcon commun séparé.",
      it: "Questa suite dispone di un balcone privato riservato solo a questa camera, arredato con tavolo e sedie. L'accesso al balcone privato avviene tramite un balcone comune separato.",
      bg: 'Този суит разполага със собствен балкон само за тази стая, обзаведен с маса и столове. Достъпът до собствения балкон е през отделен общ балкон.',
      mk: 'Овој апартман има приватен балкон само за оваа соба, опремен со маса и столици. Пристапот до приватниот балкон е преку посебен заеднички балкон.',
      ru: 'У этого номера есть собственный балкон со столом и стульями. Балкон принадлежит только этому номеру, но вход на него проходит через отдельный общий балкон.',
      uk: 'У цьому номері є власний балкон зі столом і стільцями, призначений лише для цього номера. Вхід на власний балкон здійснюється через окремий спільний балкон.',
    },
    photos: [
      '/images/3/Victoria_01.jpg',
      '/images/3/Victoria_02.jpg',
      '/images/3/Victoria_03.jpg',
      '/images/3/Victoria_04.jpg',
      '/images/3/Victoria_05.jpg',
      '/images/3/Victoria_06.jpg',
      '/images/3/Victoria_07.jpg',
      '/images/3/Victoria_08.jpg',
      '/images/3/Victoria_09.jpg',
      '/images/3/Victoria_10.jpg',
      '/images/3/Victoria_11.jpg',
      '/images/3/Victoria_12.jpg',
      '/images/3/Victoria_13.jpg',
      '/images/3/Victoria_14.jpg',
      '/images/3/Victoria_15.jpg',
      '/images/3/Victoria_16.jpg',
      '/images/3/Victoria_17.jpg',
      '/images/3/Victoria_18.jpg',
    ],
    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 88 },
      { dates: '01/06-30/06', minStay: 3, rate: 88 },
      { dates: '01/07-31/07', minStay: 2, rate: 97 },
      { dates: '01/08-31/08', minStay: 3, rate: 143 },
      { dates: '01/09-30/09', minStay: 4, rate: 143 },
    ],
  },
  {
    size: 25,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: true,
    cityview: true,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 1,
    single_beds: 0,
    terrace: true,
    balcony: true,
    id: 4,
    name: 'Alexander',
    longName: 'Junior Suite with Balcony Alexander',
    desc: {
      en: 'Boasting a private entrance, this air-conditioned suite features a kitchen, 1 bedroom and 1 bathroom with a walk-in shower and a hairdryer. Guests can make meals in the kitchen that has a stovetop, a refrigerator, kitchenware and a microwave. Featuring an outdoor dining area, this suite also features soundproof walls, a tea and coffee maker and a flat-screen TV with satellite channels. The unit has 1 bed.',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/4/Alexander_01.jpg',
      '/images/4/Alexander_02.jpg',
      '/images/4/Alexander_03.jpg',
      '/images/4/Alexander_04.jpg',
      '/images/4/Alexander_05.jpg',
      '/images/4/Alexander_06.jpg',
      '/images/4/Alexander_07.jpg',
      '/images/4/Alexander_08.jpg',
      '/images/4/Alexander_09.jpg',
      '/images/4/Alexander_10.jpg',
      '/images/4/Alexander_11.jpg',
      '/images/4/Alexander_12.jpg',
      '/images/4/Alexander_13.jpg',
      '/images/4/Alexander_14.jpg',
      '/images/4/Alexander_15.jpg',
      '/images/4/Alexander_16.jpg',
      '/images/4/Alexander_17.jpg',
    ],

    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 88 },
      { dates: '01/06-30/06', minStay: 3, rate: 94 },
      { dates: '01/07-31/07', minStay: 2, rate: 133 },
      { dates: '01/08-31/08', minStay: 3, rate: 154 },
      { dates: '01/09-30/09', minStay: 4, rate: 154 },
    ],
  },
  {
    size: 30,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: true,
    cityview: true,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 1,
    single_beds: 0,
    terrace: true,
    balcony: false,
    id: 5,
    name: 'Nefeli',
    longName: 'Junior Suite with Terrace Nefeli',
    desc: {
      en: 'Description in English',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/5/Nefeli_01.jpg',
      '/images/5/Nefeli_02.jpg',
      '/images/5/Nefeli_03.jpg',
      '/images/5/Nefeli_04.jpg',
      '/images/5/Nefeli_05.jpg',
      '/images/5/Nefeli_06.jpg',
      '/images/5/Nefeli_07.jpg',
      '/images/5/Nefeli_08.jpg',
      '/images/5/Nefeli_09.jpg',
      '/images/5/Nefeli_10.jpg',
      '/images/5/Nefeli_11.jpg',
      '/images/5/Nefeli_12.jpg',
      '/images/5/Nefeli_13.jpg',
      '/images/5/Nefeli_14.jpg',
      '/images/5/Nefeli_15.jpg',
      '/images/5/Nefeli_16.jpg',
      '/images/5/Nefeli_17.jpg',
      '/images/5/Nefeli_18.jpg',
      '/images/5/Nefeli_19.jpg',
      '/images/5/Nefeli_20.jpg',
      '/images/5/Nefeli_21.jpg',
    ],

    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 88 },
      { dates: '01/06-30/06', minStay: 3, rate: 110 },
      { dates: '01/07-31/07', minStay: 2, rate: 123 },
      { dates: '01/08-31/08', minStay: 3, rate: 134 },
      { dates: '01/09-30/09', minStay: 4, rate: 134 },
    ],
  },
  {
    size: 20,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: false,
    cityview: false,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 1,
    single_beds: 0,
    terrace: false,
    balcony: false,
    id: 6,
    name: 'Areti',
    longName: 'Deluxe Triple Areti',
    desc: {
      en: 'Description in English',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/6/Areti_01.jpg',
      '/images/6/Areti_02.jpg',
      '/images/6/Areti_03.jpg',
      '/images/6/Areti_04.jpg',
      '/images/6/Areti_05.jpg',
      '/images/6/Areti_06.jpg',
      '/images/6/Areti_07.jpg',
      '/images/6/Areti_08.jpg',
      '/images/6/Areti_09.jpg',
      '/images/6/Areti_10.jpg',
    ],

    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 88 },
      { dates: '01/06-30/06', minStay: 3, rate: 88 },
      { dates: '01/07-31/07', minStay: 2, rate: 111 },
      { dates: '01/08-31/08', minStay: 3, rate: 119 },
      { dates: '01/09-30/09', minStay: 4, rate: 119 },
    ],
  },
  {
    size: 20,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: false,
    cityview: false,
    gardenview: true,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 0,
    single_beds: 0,
    terrace: true,
    balcony: false,
    id: 7,
    name: 'Erato',
    longName: 'Deluxe Double Room ERATO',
    desc: {
      en: 'Description in English',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/7/delux20m_01.jpg',
      '/images/7/delux20m_02.jpg',
      '/images/7/delux20m_03.jpg',
      '/images/7/delux20m_04.jpg',
      '/images/7/delux20m_05.jpg',
      '/images/7/delux20m_06.jpg',
      '/images/7/delux20m_07.jpg',
      '/images/7/delux20m_08.jpg',
      '/images/7/delux20m_09.jpg',
      '/images/7/delux20m_10.jpg',
      '/images/7/delux20m_11.jpg',
      '/images/7/delux20m_12.jpg',
      '/images/7/delux20m_13.jpg',
      '/images/7/delux20m_14.jpg',
      '/images/7/delux20m_15.jpg',
      '/images/7/delux20m_16.jpg',
      '/images/7/delux20m_17.jpg',
    ],
    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 88 },
      { dates: '01/06-30/06', minStay: 3, rate: 88 },
      { dates: '01/07-31/07', minStay: 2, rate: 107 },
      { dates: '01/08-31/08', minStay: 3, rate: 113 },
      { dates: '01/09-30/09', minStay: 4, rate: 113 },
    ],
  },
  {
    size: 12,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: false,
    cityview: false,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 0,
    single_beds: 0,
    terrace: false,
    balcony: false,
    id: 8,
    name: 'Ariadni',
    longName: 'Deluxe Double Room ARIADNI',
    desc: {
      en: 'Description in English',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/8/delux12mr_01.jpg',
      '/images/8/delux12mr_02.jpg',
      '/images/8/delux12mr_03.jpg',
      '/images/8/delux12mr_04.jpg',
      '/images/8/delux12mr_05.jpg',
      '/images/8/delux12mr_06.jpg',
      '/images/8/delux12mr_07.jpg',
      '/images/8/delux12mr_08.jpg',
      '/images/8/delux12mr_09.jpg',
      '/images/8/delux12mr_10.jpg',
      '/images/8/delux12mr_11.jpg',
    ],
    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 77 },
      { dates: '01/06-30/06', minStay: 3, rate: 77 },
      { dates: '01/07-31/07', minStay: 2, rate: 99 },
      { dates: '01/08-31/08', minStay: 3, rate: 110 },
      { dates: '01/09-30/09', minStay: 4, rate: 110 },
    ],
  },
  {
    size: 12,
    capacity: 2,
    kitchen: true,
    private_bathroom: true,
    seaview: false,
    cityview: false,
    gardenview: false,
    air_conditioning: true,
    flat_screen_tv: true,
    free_wifi: true,
    extra_large_double_beds: 1,
    double_beds: 0,
    single_sofas: 0,
    double_sofas: 0,
    single_beds: 0,
    terrace: false,
    balcony: false,
    id: 9,
    name: 'Afroditi',
    longName: 'Deluxe Double Room AFRODITI',
    desc: {
      en: 'Description in English',
      el: 'Περιγραφή στα Αγγλικά',
    },
    photos: [
      '/images/9/delux12m_01.jpg',
      '/images/9/delux12m_02.jpg',
      '/images/9/delux12m_03.jpg',
      '/images/9/delux12m_04.jpg',
      '/images/9/delux12m_05.jpg',
      '/images/9/delux12m_06.jpg',
      '/images/9/delux12m_07.jpg',
      '/images/9/delux12m_09.jpg',
      '/images/9/delux12m_10.jpg',
      '/images/9/delux12m_11.jpg',
      '/images/9/delux12m_12.jpg',
      '/images/9/delux12m_13.jpg',
    ],
    price: [
      { dates: '01/05-31/05', minStay: 4, rate: 77 },
      { dates: '01/06-30/06', minStay: 3, rate: 77 },
      { dates: '01/07-31/07', minStay: 2, rate: 99 },
      { dates: '01/08-31/08', minStay: 3, rate: 119 },
      { dates: '01/09-30/09', minStay: 4, rate: 119 },
    ],
  },
];
